import { render, staticRenderFns } from "./manuallyAdd.vue?vue&type=template&id=80de2cf6&scoped=true"
import script from "./manuallyAdd.vue?vue&type=script&lang=js"
export * from "./manuallyAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80de2cf6",
  null
  
)

export default component.exports